import * as R from "ramda";
import { createHandlers } from "redux-mvc";
import { NAMESPACE, TABS } from "./constants";

const iniState = {
  loading: true,
  history: null,
  selectedTab: TABS.CONTACT_GROUP,
  recordId: null,
  contactData: {},
  aboutData: {},
  eventList: [],
  sessions: {},
  applications: [],
  contactsList: []
};

const model = createHandlers({
  iniState,
  reducers: {
    init: R.identity,
    initData: R.identity,
    copyPortalLink: R.identity,
    showSendEmailModal: R.identity,
    updateContactCardField: R.identity,
    saveAboutCardField: R.identity,
    goToAgenda: R.identity,
    openSession: R.identity,
    updateSessionCard: R.identity,
    updateApplicationCard: R.identity,
    setInitialContactGroupData: (
      _,
      { payload: { contactData, aboutData, eventList, sessions, contactsList } }
    ) => ({
      contactData,
      aboutData,
      eventList,
      sessions,
      contactsList
    })
  },
  namespace: NAMESPACE
});

const { actions, getters } = model;

export { actions, getters };

export default model;
